import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Kaari & Co. (b_7xqoxri3cq, advertiser 1756243082779176848).
// Real numbers from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (lifetime totals; 31-month tenure from Feb 2024). NEW_AND_RETURNING with
// separate campaign budgets. Scaling up: new-customer spend went from $102 in
// Apr 2026 to $584 in Jul and $448 in the first three weeks of Aug, while the
// reorder campaign stays nearly dormant at 5 lifetime conversions. The only one
// of the three new brands the platform is recommending a budget increase for.
// Monthly series (complete months Aug 2025 – Jul 2026) + partial Aug 2026 live
// in realBrandData.ts.
//
// `budget` is the platform's standing budget recommendation, not a reported
// figure: this advertiser reports no monthly budget for any month shown.
// `spendingMode` is not in the source data and is set here only so the growth-mode
// module has a defined default.
export const advKaariCo: FaireAdvertiserProfileEntity = {
  token: "adv_kaari_co",
  type: "advertiserProfile",
  archetype: "big-budget-under-utilized",
  displayName: "Kaari & Co.",
  brandToken: "b_7xqoxri3cq",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 31,
  budget: {
    totalBudgetDollars: 1010,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 59,
    numReorderConversions: 5,
    numTotalConversions: 64,
    totalAdsSalesDollars: 20931,
    newCustomerAdsSalesDollars: 18702,
    reorderAdsSalesDollars: 2229,
    totalAdsSpendDollars: 5366,
    newCustomerAdsSpendDollars: 5088,
    reorderAdsSpendDollars: 278,
    newCustomerBestEstimateFirstYearRoas: 3.68,
    reorderRoas: 8.03,
    combinedFirstYearRoas: 3.9,
    // MANAGER_METRICS_BRAND_ORDERS: 95 orders on the new-customer campaign
    // (from 59 acquired customers) and 5 on the reorder campaign.
    numNewCustomerAdsOrders: 95,
    numReorderAdsOrders: 5,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 910,
      maxRecommendedBudgetDollars: 1820,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
    },
  },
  campaignTokens: ["camp_kc_new", "camp_kc_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
